<template>
<svg viewBox="0 0 15 15" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Zan`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.24457 3.2152C6.09023 1.806 4.21715 2.01091 3.13054 2.48631C1.90983 2.84507 -0.737058 5.22443 1.73163 9.29111C2.98798 11.3607 5.45656 13.045 7.26287 13.6712C8.54695 13.4325 11.4354 11.6457 12.9502 9.09778C15.1719 5.36056 12.7238 1.7034 9.15546 2.25933C8.71552 2.32787 7.96723 2.57422 7.24457 3.2152ZM6.78584 4.75507C6.0218 3.88713 5.31591 3.39991 3.88613 3.67733C2.90192 3.96658 1.04394 5.43026 2.90477 8.5446C3.71362 9.89832 5.79867 11.6475 7.25501 12.1524C8.29031 11.9599 10.6581 10.2308 11.8308 8.1738C13.4174 5.39102 11.276 2.66051 8.63049 3.89993C8.39446 4.01052 8.18672 4.22477 7.93853 4.48076C7.83422 4.58835 7.72276 4.70331 7.59904 4.82104C7.36489 5.04388 6.99943 4.9977 6.78584 4.75507Z"/></svg>
</template>
<script>

export default {
  name: 'IconZan',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
